/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchResultDto } from '../../models/search-result-dto';

export interface SearchGet$Plain$Params {
  term?: string;
  page?: number;
  pageSize?: number;
}

export function searchGet$Plain(http: HttpClient, rootUrl: string, params?: SearchGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SearchResultDto>>> {
  const rb = new RequestBuilder(rootUrl, searchGet$Plain.PATH, 'get');
  if (params) {
    rb.query('term', params.term, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SearchResultDto>>;
    })
  );
}

searchGet$Plain.PATH = '/search';
